const registerModule = {
  title1: "請輸入電話號碼",
  title2: "驗證碼將通過短信發送",
  register: "註冊",
  nextStep: "下一步",
  areaCodeTitle: "手機區號選擇",
  resendText: "*後可再次發送驗證碼",
  codePrompt: "請輸入您收到的四位數驗證碼",
  setPassword: "設置密碼",
  sendCodeText:
    "我們將向上述手機號發送短信驗證碼。受通訊情況影響，收信時間可能會有延遲。",
  isPhone: "請填寫手機號",
  sendCodeAgain: "再次發送短信至*",
  sendSuccess: "發送成功",
  passwordHint: "請輸入6-32位的半角英文或數字",
  isPassword: "密碼不能為空",
  samePassword: "兩次密碼不相同",
  registerSuccess: "註冊成功",
  forgetPwTitle: "忘記密碼",
  newPassword: "新密碼",
  restSuccess: "修改成功",
  sendCode: "獲取驗證碼",
  requiredEmail: '請填寫郵箱',
  phoneError: "手機號格式不正確",
};

export default registerModule;
